'use client'

import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect } from 'react'

export function GTMPageView() {
  const pathname = usePathname()
  const searchParams = useSearchParams()

  useEffect(() => {
    if (typeof window !== 'undefined' && window.dataLayer) {
      const url = pathname + (searchParams?.toString() ? `?${searchParams.toString()}` : '')

      window.dataLayer.push({
        event: 'page_view_spa',
        page_path: pathname,
        page_location: window.location.href,
        page_url: url,
      })
    }
  }, [pathname, searchParams])

  return null
}
